"use client";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Skeleton } from "@/components/ui/skeleton";

export function UserReportsSkeleton() {
  // Create an array to represent the loading rows
  const loadingRows = Array.from({ length: 10 }, (_, i) => i);

  return (
    <div className="w-full">
      <div className="p-4 flex items-center justify-between">
        <div className="flex-1 max-w-sm">
          <Skeleton className="h-10 w-[250px]" />
        </div>
        <div>
          <Skeleton className="h-5 w-[200px]" />
        </div>
      </div>

      <Table>
        <TableHeader>
          <TableRow className="bg-muted/50">
            <TableHead className="w-[250px]">Name</TableHead>
            <TableHead className="w-[200px]">Role</TableHead>
            <TableHead className="text-center w-[150px]">Assigned Policies</TableHead>
            <TableHead className="text-center w-[120px]">Reading %</TableHead>
            <TableHead className="text-center w-[100px]">Quiz %</TableHead>
            <TableHead className="w-[150px]">Status</TableHead>
            <TableHead className="w-[80px] text-right"></TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {loadingRows.map((index) => (
            <TableRow key={index}>
              <TableCell>
                <Skeleton className="h-5 w-[180px]" />
              </TableCell>
              <TableCell>
                <Skeleton className="h-5 w-[120px]" />
              </TableCell>
              <TableCell className="text-center">
                <Skeleton className="h-5 w-8 mx-auto" />
              </TableCell>
              <TableCell className="text-center">
                <Skeleton className="h-5 w-12 mx-auto" />
              </TableCell>
              <TableCell className="text-center">
                <Skeleton className="h-5 w-12 mx-auto" />
              </TableCell>
              <TableCell>
                <Skeleton className="h-6 w-24" />
              </TableCell>
              <TableCell className="text-right">
                <Skeleton className="h-8 w-8 rounded-md ml-auto" />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <div className="flex items-center justify-center py-4">
        <Skeleton className="h-10 w-[300px]" />
      </div>
    </div>
  );
}
